import React from 'react';
import useForm from '../../../hooks/formHook';
import Username from '../../../static/dashboard/username.svg';

export default function SettingsDepop({ history }) {
    const { formData, handleChange } = useForm({
        username: ''
    });

    return (
        <form 
        className="formDashboard"
        onSubmit={(e) => history.push('/dashboard/settings/depop/changedepop')}>
            <label htmlFor="username">Your Depop</label>
            <div className="username">
                <div><img src={Username} alt=""/></div>
                <input 
                className="withIcon"
                type="text"
                name="username"
                value={formData.username}
                placeholder="username"
                onChange={handleChange}
                />
            </div>
            <input 
                className="alert-button"
                type="submit"
                value="Change Account" />
        </form>
    )
}
